import { Card } from '@repo/shadcn';

import { IwForm } from '@components/form';
import { HeaderBreadcrumb } from '@components/ui';
import PageHeading from '@components/ui/heading/page-headeing';

import { Route } from '@/constants';
import {
    CreateSalesReturnProvider,
    useCreateSalesReturnContext,
} from '@/modules/sales-return/create-sales-return/create-sales-return.context';
import { OrderSelector } from '@/modules/sales-return/create-sales-return/order-selector.component';

import { SaleReturnOverview } from './details.component';
import { Items } from './items.component';
import { CreateSalesReturnForm, CreateSalesReturnFormSchema } from './schema';

const CreateSalesReturnComponent = () => {
    const { submitCreateSalesReturn, formRef } = useCreateSalesReturnContext();
    // useEffect(() => {
    //     console.log(formRef.current);
    // }, [formRef]);
    return (
        <IwForm
            schema={CreateSalesReturnFormSchema}
            initialValues={{ items: [] }}
            ref={formRef}
            onSubmit={(values) => {
                submitCreateSalesReturn(values as CreateSalesReturnForm);
            }}
        >
            <Card className={'space-y-4 p-4'}>
                <div className={'space-y-4'}>
                    <HeaderBreadcrumb
                        items={[
                            {
                                label: 'Sales Return',
                                href: Route.SALES_RETURNS,
                            },
                            {
                                label: 'Create Sales Return',
                            },
                        ]}
                    />
                    <PageHeading title={'Create Sales Return'} subTitle={''} />
                </div>

                <OrderSelector />
                <div className={'mt-4 grid grid-cols-[2fr_1fr] gap-4'}>
                    <Items />
                    <SaleReturnOverview />
                </div>
            </Card>
        </IwForm>
    );
};

export const CreateSalesReturn = () => {
    return (
        <CreateSalesReturnProvider>
            <CreateSalesReturnComponent />
        </CreateSalesReturnProvider>
    );
};

CreateSalesReturn.displayName = 'CreateSalesReturn';
